import { Modal } from "react-bootstrap";
import { useRef } from "react";
import { toast } from "react-toastify";
import { toPng } from "html-to-image";

export const PODModal = ({
  show,
  handleCloseModal,
  podSignature,
  podName,
  showPodComment = true,
  podComment,
  orderLevel, // true for order level POD in order tracking history, false for package/barcode level POD in parcel tracking history
  deliveryId,
  barcode,
  mainInvoice,
}) => {
  const PODRef = useRef();
  const handleGenerateAndDownloadPOD = () => {
    if (PODRef.current === null) {
      return;
    }
    toPng(PODRef.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        //feel like it would be easier to track with delivery id attached but w.e.
        // link.download = `${
        //   orderLevel
        //     ? "Diligent Order Level POD for order " +
        //       deliveryId +
        //       " - Signed By " +
        //       podName
        //     : "Diligent POD for Barcode " + barcode + " - Signed By " + podName
        // }.png`;
        link.download = `${
          orderLevel
            ? "Diligent Order Level POD for Invoice " +
              mainInvoice +
              " - Signed By " +
              podName +
              ` (Delivery ID ${deliveryId})`
            : "Diligent POD" +
              (mainInvoice ? " for Invoice " + mainInvoice : "") +
              " - Signed By " +
              podName +
              ` (Barcode ${barcode})`
        }.png`;
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        // console.log(error);
        toast.error("Issue downloading POD");
      });
  };
  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      // dialogClassName="signature-modal"
    >
      <Modal.Header>
        <Modal.Title>Signature</Modal.Title>
      </Modal.Header>
      <Modal.Body
        //providing Modal.Body ref and className for downloading it as an image. Need to make background white as it is transparent to begin with. The Modal element wrapping all of this doesn't seem to take our ref and would also be the whole modal which we don't want. Just this part. Setting the ref to the div below would miss some of the padding so I went with this
        ref={PODRef}
        className="bg-white"
      >
        <div className="text-center" style={{ backgroundColor: "white" }}>
          <img
            className="pod-signature-modal-image"
            src={"data:image/svg+xml;base64," + podSignature}
            alt="Signature"
          />
          <p>
            Signed By: {podName ? podName : "N/A"}
            {showPodComment && (
              <>
                <br />
                Comment: <br />
                {podComment ? podComment : "N/A"}
              </>
            )}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-primary"
          onClick={handleGenerateAndDownloadPOD}
        >
          Download
        </button>
        <button className="btn btn-secondary" onClick={handleCloseModal}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
